import React from 'react';
import {observer} from "mobx-react";
import {PropositionBetsWidgetSection} from "./proposition-bets-widget.section";

export const PropositionBetsWidgetSections = observer(({controller, isPreview, bet, isExpanded}) => {
  const {sections} = bet;

  return (
    isExpanded ? <>
      {
        sections.map(section => <PropositionBetsWidgetSection
          controller={controller}
          isPreview={isPreview}
          section={section}
          bet={bet}
          key={section.competitorId}
        />)
      }
    </> : null
  )
});
